




































































import Vue from "vue";
import Component from "vue-class-component";
import StringField from "../../../shared/fields/StringField.vue";
import RequiredSexe from "../../../shared/fields/RequiredSexe.vue";
import DateField from "../../../shared/fields/DateField.vue";
import Btn from "../../../shared/Btn.vue";
import { ValidEvent } from "../../../shared/utils";
import { InscriptionSimple } from "@/shared/logic/types";
import { Sexe } from "@/shared/logic/types";
import { nullDateString } from "@/shared/logic/utils";

const FormInscriptionProps = Vue.extend({});

@Component({
  components: { StringField, RequiredSexe, DateField, Btn }
})
export default class FormInscription extends FormInscriptionProps {
  validated = false;

  inscription: InscriptionSimple = {
    nom: "",
    prenom: "",
    sexe: Sexe.SAucun,
    date_naissance: nullDateString,
    mail: "",
    tel: "",
    info: ""
  };

  $refs!: {
    form: HTMLFormElement;
  };

  valid(event: ValidEvent) {
    this.validated = true;
    if (this.$refs.form.checkValidity()) {
      this.$emit("save", event, this.inscription);
    }
  }
}
